import parent from '@/store/interfaces/historicalGeneric'
const mystore = parent({ tipoEvento: 'verifactu', namespaced: true })

export default mystore
